import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { LocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/locations/location.model';
import { CellContext } from '@tanstack/react-table';

import i18n from '@app/core/locale/i18n';

export interface EmspBoEmspLocationListLastUpdatedCellProps
  extends CellContext<LocationModel, LocationModel['last_updated']> {}

export const EmspBoLocationListLastUpdatedCell = (
  props: EmspBoEmspLocationListLastUpdatedCellProps,
): React.JSX.Element => {
  const { getValue } = props;

  return (
    <Text truncate>{getValue() ? formatDate(getValue()!, i18n) : '-'}</Text>
  );
};
